import { Trans, useT } from '@eturi/react-i18next'
import OpjQrCodeImg from '@op/assets/connect/opj-qr-code.svg'
import { activeChildId$, fetchPairingCode } from '@op/services'
import { memo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '../../types'
import { HybridModal, LoadingSpinner, useToasts } from '../../widgets'

type QuickPairModalProps = {
	readonly onClose: () => void
}

const QuickPairModal = ({ onClose }: QuickPairModalProps) => {
	const d = useAppDispatch()
	const [t] = useT('connect.pair_modals')
	const { addErrorToast } = useToasts()

	const activeChildId = useSelector(activeChildId$)
	const [pairingCode, setPairingCode] = useState<string | null>(null)

	useEffect(() => {
		if (!activeChildId) return

		const fetchAndSetPairCode = async (childUserId: string) => {
			try {
				const nextPairCode = await d(fetchPairingCode({ childUserId })).unwrap()
				if (nextPairCode?.pair_code) setPairingCode(nextPairCode.pair_code)
			} catch (err) {
				console.error('Failed to fetch pairing code:', err)
				addErrorToast(t.$('connect.ios_pairing.fetch_pairing_code_error'))
			}
		}

		fetchAndSetPairCode(activeChildId)
	}, [activeChildId])

	return (
		<HybridModal header={t.$('actions.quick_pair')} onClose={onClose}>
			<div className="flex flex-col max-w-full sm:max-w-105 md:max-w-105 mx-auto">
				<p className="text-balance text-center mb-6">
					<Trans i18nKey="quick_pair_modal_description" t={t} />
				</p>

				<ol className="list-decimal flex flex-col items-center gap-4 pb-2 px-4">
					<li>
						<Trans i18nKey="quick_pair_modal_instruction_1" t={t} />
					</li>

					<img className="w-48 sm:w-1/2 my-3" src={OpjQrCodeImg} alt="OurPact Jr QR Code" />

					<li>
						<Trans i18nKey="quick_pair_modal_instruction_2" t={t} />
					</li>

					<h1 className="my-0 mx-auto mb-4 uppercase h-14 tracking-wider">
						{pairingCode || <LoadingSpinner className="!h-12 !min-h-12 !w-12 !min-w-12 p-0 !m-0" />}
					</h1>
				</ol>
			</div>
		</HybridModal>
	)
}

export default /*@__PURE__*/ memo(QuickPairModal)
